const copyObject = (object) => {
  try {
    return JSON.parse(JSON.stringify(object))
  } catch (e) {
    console.error(e)
    return object
  }
}

export default copyObject
